import React, { Component } from 'react'
import css from './style.css'
import _ from 'lodash'
import Checkbox from '../../components/checkbox'
import { ItemName, ItemStats } from '../../components/item-header'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import {
  getJewelryPrices,
  getClientBudgetForDiamond,
  getAppraisalCosts
} from '../../selectors/cart'
import Spacer from '../../components/spacer'
import HorizontalRule from '../../components/horizontal-rule'
import PlusIcon from 'react-icons/lib/fa/plus'
import Edit from 'react-icons/lib/md/edit'
import Check from 'react-icons/lib/md/check'
import Close from 'react-icons/lib/md/close'
import Eye from 'react-icons/lib/md/remove-red-eye'
import Button from '../../components/button'
import { OrderLine, OrderLineInput } from '../../components/order-line'
import * as actions from '../../actions/cart'
import {
  setFindADiamondParams,
  search,
  getAllSuppliers
} from '../../actions/search'
import { toggleDisplayCart } from '../../actions/settings'
import { openModal as openJewelryModal } from '../../actions/jewelry-search'
import SearchIcon from 'react-icons/lib/fa/search'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.cart,
    jewelryPrices: getJewelryPrices(state),
    budgetForFindADiamond: getClientBudgetForDiamond(state),
    appraisalCosts: getAppraisalCosts(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    jewelryDetails: (row, additionalNotes, e) => {
      dispatch(openJewelryModal(row, additionalNotes))
      if (e) e.preventDefault()
    },
    removeJewelry: (id) => {
      dispatch(actions.removeJewelryFromCart(id))
    },
    editJewelry: (id, data, filters) => {
      dispatch(actions.editJewelryClicked(id, data, filters))
    },
    setDescriptionEditing: (id, descriptionEditing) => {
      dispatch(actions.setDescriptionEditing(id, descriptionEditing))
    },
    updateDescription: (id, description) => {
      dispatch(actions.setDescriptionEditing(id, false))
      if (description.trim().length) {
        dispatch(actions.updateDescription(id, description))
      }
    },
    appraisalCostChanged: (jewelryId, event) => {
      dispatch(actions.appraisalCostChanged(jewelryId, event.target.value))
    },
    toggleItemCheckout: (type, id) => {
      dispatch(actions.toggleItemCheckout(type, id))
    },
    setDiamondSearchParams: (filters, budget) => {
      dispatch(setFindADiamondParams(filters, budget))
    },
    hideCart: () => {
      dispatch(toggleDisplayCart())
    },
    search: () => {
      dispatch(search())
    },
    getAllSuppliers: () => {
      dispatch(getAllSuppliers())
    }
  }
}

export class JewelryCartItems extends Component {
  redirectToJewelryRoute () {
    this.props.router.push('/jewellery')
  }

  redirectToSearchRoute () {
    this.props.router.push('/search')
  }

  currentRouteIsDiamondSearch () {
    return this.props.router.isActive('/search')
  }

  jewelryRedirectAndEdit (id, data, filters) {
    this.props.editJewelry(id, data, filters)
    this.redirectToJewelryRoute()
    this.props.hideCart()
  }

  clickFindADiamondBtn (filters, budget) {
    this.props.setDiamondSearchParams(filters, budget)
    // if current route is '/search', then trigger a search
    // otherwise, just redirect the route to '/search'
    if (this.currentRouteIsDiamondSearch()) {
      this.props.search()
      this.props.getAllSuppliers()
    } else {
      this.redirectToSearchRoute()
    }

    this.props.hideCart()
  }

  renderHeader (text) {
    return <div className={css.header}>{text}</div>
  }

  renderJewelryItemCollection (items) {
    const keyForTheLastItem = items ? _.last(Object.keys(items)) : 0
    return (
      <div className={css.itemsContainer}>
        {_.map(items, (item, key) => this.renderJewelryItem(item, key, keyForTheLastItem))}
      </div>
    )
  }

  renderJewelryItem ({data, checkout, filters, appraisalCost, additionalNotes, description, descriptionEditing}, key, keyForTheLastItem) {
    const type = 'jewelry'
    const props = this.props
    const isNotTheLastItem = () => key !== keyForTheLastItem
    return (
      <div key={`${type}${key}`}>
        <Checkbox checked={checkout} onChange={() => props.toggleItemCheckout(type, key)}><ItemName type={type} data={data} index={key} small /></Checkbox>
        <div className={css.description}>
          {!descriptionEditing && <ItemStats type={type} data={data} description={description} small />}
          {this.renderEditDescription(key, data, description, descriptionEditing)}
        </div>
        {this.renderJewelryActions(data, filters, key, additionalNotes)}
        <div className={css.cost}>
          <OrderLine price={props.jewelryPrices[key]} name='Cost' />
          <OrderLineInput
            name='Appraisal Cost'
            value={props.appraisalCosts[key]}
            prefix='$'
            min={0}
            onChange={(e) => props.appraisalCostChanged(key, e)} />
        </div>
        {checkout && this.renderFindADiamondButton(filters, key)}
        {isNotTheLastItem() &&
          <div key={`hr${key}`}>
            <Spacer xxs />
            <HorizontalRule />
            <Spacer xxs />
          </div>
        }
      </div>
    )
  }

  renderEditDescription (id, data, description, descriptionEditing) {
    if (descriptionEditing) {
      let updatedDescription = ''
      return (
        <div className={css.editDescription}>
          <input type='text' defaultValue={description} onChange={e => (updatedDescription = e.target.value)} />
          <div className={css.action} style={{ verticalAlign: 'middle' }}>
            <label onClick={e => this.props.updateDescription(id, updatedDescription)}><Check className={css.icon} /></label>
            <label onClick={e => this.props.setDescriptionEditing(id, false)}><Close className={css.icon} /></label>
          </div>
        </div>
      )
    }

    return (
      <div className={css.descriptionIconContainer}>
        <Edit className={css.icon} onClick={e => this.props.setDescriptionEditing(id, true)} />
      </div>
    )
  }

  renderJewelryActions (data, filters, key, additionalNotes) {
    return (
      <div className={css.action}>
        <span className='removeJewelryBtn' onClick={() => this.props.removeJewelry(key)}><PlusIcon className={[css.icon, css.rotate].join(' ')} />Remove</span>
        <span className='editJewelryBtn' onClick={() => this.jewelryRedirectAndEdit(key, data, filters)}><Edit className={css.icon} />Edit</span>
        <span className='jewelryDetailBtn' onClick={() => this.props.jewelryDetails(data, additionalNotes)}>
          <Eye className={css.icon} />Full Details
        </span>
      </div>
    )
  }

  renderFindADiamondButton (filters, key) {
    if (
      filters.jewelry_type === 'EngagementRing' ||
      filters.jewelry_type === 'Pendant' ||
      filters.jewelry_type === 'StudEarring' ||
      (filters.jewelry_type === 'StockItem' && filters.primary_diamond_qty > 0)
    ) {
      const buttonText = () => {
        if (filters.jewelry_type === 'EngagementRing' || filters.jewelry_type === 'Pendant') {
          return 'Find a Diamond'
        } else if (filters.jewelry_type === 'StudEarring') {
          return 'Find Diamonds'
        } else if (filters.jewelry_type === 'StockItem') {
          return 'Find Diamond(s)'
        }
      }
      const disableBtn = (budgetForFindADiamond, filters) => {
        if (budgetForFindADiamond <= 0) {
          return true
        }
        if (filters.jewelry_type === 'StockItem' && filters.primary_diamond_qty < 1) {
          return true
        }
        return false
      }
      return (
        <div>
          <Spacer xxs />
          <Button center alt buttonId={`find-a-diamond-btn-${key}`} className='findADiamondBtn' onClick={() => {
            this.clickFindADiamondBtn(filters, this.props.budgetForFindADiamond)
          }} disabled={disableBtn(this.props.budgetForFindADiamond, filters)}>
            <i><SearchIcon /></i> {buttonText()}
          </Button>
        </div>
      )
    }
  }

  render () {
    return (
      <div>
        {this.renderHeader('Jewellery')} {this.renderJewelryItemCollection(this.props.jewelry)}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JewelryCartItems))



// WEBPACK FOOTER //
// ./src/containers/cart/jewelry-cart-items.js